export default {
    ABK: "business trip",
    PRI: "private trip",
    RTA: "communication work",
    ATK: "other servicable driving",
    LÅN: "rentalcar",
    LØNST: "salarybasedstop",
    SÆDST: "semenpickup",
    PKRE: "private driving to area",
    PK: "privatedrive",
    SVIK: "sideshow",
    PAS: "passenger"
}